// 节点类型 
export const ELEMENT_TYPE = 'imgLoading';
export const MENU_KEY = 'xh_img_loading_key';
export const MENU_NAME = 'loading';
export const MENU_ICON = ''